import React, { useEffect, useState } from "react";
import NewsImg3 from "../../../assests/NewsImg3.png";
import Footer from "../../Footer";

// Header import File
import ContactbannerImg from "../../../assests/contactBanner.jpg";
import prelorder from "../../../assests/loading/logo.png";
import Logo from "../../../assests/mediLogo.png";
import { Link, NavLink } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay } from "swiper/modules";
import axios from "axios";
import { baseUrl } from "../../Api/BaseUrl";
import { baseImg } from "../../Api/ImageUrl";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaGooglePlusG,
  FaYoutube,
} from "react-icons/fa";
// Header import File

// Localization data
const headerTranslations = {
  1: {
    news: "News",
    agency: "Agency",
    services: "Services",
    work: "Work",
    team: "Team",
    contact: "Contact Us",
    hanaya: "Hanaya Ooredoo",
    email: "Email",
    address: "Address",
    ourservices: "Our Services",
  },
  2: {
    news: "Nouvelles",
    agency: "Agence",
    services: "Services",
    work: "Travail",
    team: "Équipe",
    contact: "Contactez",
    hanaya: "Hanaya Ooredoo",
    email: "e-mail",
    address: "Adresse",
    ourservices: "Nos prestations",
  },
  3: {
    news: "الأخبار",
    agency: "وكالة",
    services: "الخدمات",
    work: "العمل",
    team: "الفريق",
    contact: "اتصل بنا",
    hanaya: "حنايا أوريدو",
    email: "بريد إلكتروني",
    address: "عنوان",
    ourservices: "خدماتنا",
  },
};
const HanayaOoredoo = () => {
  // ------- Header Import Code-------
  const [isOverflow, setIsOverflow] = useState(false);
  const [Active, setActive] = useState(false);
  const [language, setLanguage] = useState(1);
  const [aboutHanaya, setAboutHanaya] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [footerData, setFooterData] = useState(null);

  // Search toggle
  const toggleSearch = () => {
    setIsSearchOpen((prev) => !prev);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const searchQuery = e.target.elements.q.value;
    console.log("Search query:", searchQuery);
  };

  // ToogleControl Method
  const handleToggleClick = () => {
    if (Active) {
      setIsOverflow(!isOverflow);
      setActive(false);
      setTimeout(() => {
        document.querySelector(".all-cases").style.transitionDelay = "0.5s";
        document.querySelector(".all-cases .layer").style.transitionDelay =
          "0.3s";
        document.querySelector(".all-cases .inner").style.transitionDelay =
          "0s";
      }, 0);
    } else {
      setActive(true);
      setIsOverflow(!isOverflow);
      setTimeout(() => {
        document.querySelector(".all-cases.active").style.transitionDelay =
          "0s";
        document.querySelector(
          ".all-cases.active .layer"
        ).style.transitionDelay = "0.2s";
        document.querySelector(
          ".all-cases.active .inner"
        ).style.transitionDelay = "0.7s";
      }, 0);
    }
  };

  // ------- Header Import Code End-------

  useEffect(() => {
    const fetchHanayaData = async () => {
      try {
        const response = await axios.post(`${baseUrl}get_cms_news_section`, {
          language: language,
        });
        setAboutHanaya(response.data.Details);
      } catch (error) {
        console.log("Error The Fetching Data from Hanaya Details:", error);
      }
    };
    const fetchFooter = async () => {
      try {
        const response = await axios.post(`${baseUrl}get_footer_section`, {
          language: language,
        });
        setFooterData(response.data.Details);
      } catch (error) {
        console.error("Error fetching the Footer Data:", error);
      }
    };
    fetchFooter();
    fetchHanayaData();
  }, [language]);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      setLanguage(Number(savedLanguage));
    }
  }, []);
  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  const handleLanguage = (e) => {
    e.preventDefault();
    setLanguage(Number(e.target.value));
  };

  return (
    <>
      {/* Header & Banner Section Start */}
      <div>
        <div className="preloader">
          <div className="layer"></div>
          <div className="inner">
            <figure>
              <img src={prelorder} alt="Img" />
            </figure>
            <span>The Art of Contact and the Science of Data</span>
          </div>
        </div>

        <div className={`all-cases ${Active ? "active" : ""}`}>
          <div className="layer"> </div>
          <aside className="left-side left-side2">
            <div className="follow-us">FOLLOW US</div>
            <ul>
              <li>
                <Link to="#">
                  <i className="fab fa-facebook-f"></i>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="fab fa-twitter"></i>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="fab fa-linkedin-in"></i>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="fab fa-google-plus-g"></i>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="fab fa-youtube"></i>
                </Link>
              </li>
            </ul>
            <div className="equalizer">
              <span></span> <span></span> <span></span> <span></span>
            </div>
          </aside>
          <div className="inner">
            <ul>
              <li>
                <NavLink
                  to="/news"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.news}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/agency"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.agency}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/services"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.services}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/work"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.work}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/team"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.team}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/contact"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.contact}
                </NavLink>
              </li>
            </ul>
          </div>
        </div>

        <main>
          <div>
            <div className="main_header">
              <div
                className="completeMenu"
                style={{
                  background: "black",
                }}
              >
                <div className="logo">
                  <Link to="/">
                    <img src={Logo} alt="Img" />
                  </Link>
                </div>
                <div className="all-cases-link">
                  <span className="">
                    <div className="nav-open_main d-flex">
                      <nav className={`nav ${menuOpen ? "nav-open" : ""}`}>
                        <NavLink
                          to="/news"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.news}
                        </NavLink>
                        <NavLink
                          to="/agency"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.agency}
                        </NavLink>
                        <NavLink
                          to="/services"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.services}
                        </NavLink>
                        <NavLink
                          to="/work"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.work}
                        </NavLink>
                        <NavLink
                          to="/team"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.team}
                        </NavLink>
                        <NavLink
                          to="/contact"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.contact}
                        </NavLink>
                      </nav>
                      <div className="d-flex nav-open_main1">
                        <div className="language-switching">
                          <select value={language} onChange={handleLanguage}>
                            <option value={1}>ENG</option>
                            <option value={2}>FRE</option>
                            <option value={3}>عربي</option>
                          </select>
                        </div>
                        <div className="searching-toggle mx-0">
                          <div
                            className={`search-toggle ${
                              isSearchOpen ? "opened" : "closed"
                            }`}
                          >
                            <button
                              className="search-icon icon-search"
                              onClick={toggleSearch}
                            >
                              <i className="fa fa-fw fa-search"></i>
                            </button>
                            <button
                              className="search-icon icon-close"
                              onClick={toggleSearch}
                              style={{
                                display: isSearchOpen ? "inline-block" : "none",
                              }}
                            >
                              <i className="fa fa-fw fa-close"></i>
                            </button>
                          </div>

                          <div
                            className={`search-container d-flex ${
                              isSearchOpen ? "opened" : "closed"
                            }`}
                            style={{ display: isSearchOpen ? "block" : "none" }}
                          >
                            <form onSubmit={handleSearch}>
                              <input
                                type="text"
                                name="q"
                                id="search-terms"
                                placeholder="Search terms..."
                                autoFocus={isSearchOpen}
                              />
                              <button
                                type="submit"
                                name="submit"
                                value="Go"
                                className="search-icon"
                              >
                                <i className="fa fa-fw fa-search"></i>
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </span>
                  <b onClick={handleToggleClick}>
                    <i className={`fa ${Active ? "fa-solid" : "fa-bars"}`}></i>
                  </b>
                </div>
              </div>
            </div>
            <aside className="left-side">
              <div className="follow-us">FOLLOW US</div>
              <ul>
                <li>
                  <Link to="#">
                    <i className="fab fa-facebook-f"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fab fa-twitter"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fab fa-linkedin-in"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fab fa-google-plus-g"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fab fa-youtube"></i>
                  </Link>
                </li>
              </ul>
              <div className="equalizer">
                <span></span> <span></span> <span></span> <span></span>
              </div>
            </aside>
            <div
              className={`body-content ${isOverflow ? "overflow" : ""}`}
            ></div>
          </div>

          <header className="sliderImg">
            <div className="swiper-container gallery-top">
              <div className="BannerImg">
                <img src={ContactbannerImg} alt="BannerImage" />
              </div>
            </div>
            <div className="swiper-container gallery-thumbs">
              <Swiper
                spaceBetween={0}
                slidesPerView={3}
                autoplay={{
                  delay: 9900,
                  disableOnInteraction: false,
                }}
                freeMode
                watchSlidesProgress
                centeredSlides={true}
                touchRatio={0.2}
                slideToClickedSlide={true}
                loop={true}
                loopedSlides={3}
                modules={[Autoplay]}
                breakpoints={{
                  1024: {
                    slidesPerView: 3,
                  },
                  768: {
                    slidesPerView: 1,
                  },
                  640: {
                    slidesPerView: 1,
                  },
                  320: {
                    slidesPerView: 1,
                  },
                }}
                className="swiper-wrapper"
              >
                <SwiperSlide className="swiper-slide">
                  {aboutHanaya ? (
                    <p>{aboutHanaya.sub_heading_6}</p>
                  ) : (
                    <p>{headerTranslations[language]?.hanaya}</p>
                  )}
                </SwiperSlide>
              </Swiper>
            </div>
          </header>
        </main>
      </div>
      {/* Header & Banner Section End */}
      <section className="cockStudio_wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-12 heading">
              <h3 className="headings">
                {aboutHanaya ? (
                  <span>{aboutHanaya.sub_heading_6}</span>
                ) : (
                  <p>{headerTranslations[language]?.hanaya}</p>
                )}
              </h3>
            </div>
            <div className="inner_content col-md-12 mt-4">
              <div className="mb-4">
                {aboutHanaya ? (
                  <img
                    src={`${baseImg}${aboutHanaya.image_6}`}
                    alt="workImg"
                    className="cinemaImg"
                  />
                ) : (
                  <img className="cinemaImg" src={NewsImg3} alt="ImgCinema" />
                )}
              </div>
              {aboutHanaya ? (
                <p
                  dangerouslySetInnerHTML={{
                    __html: aboutHanaya.sub_description_6
                      .replace(/\r\n/g, "<br/>")
                      .replace(/\n/g, "<br/>"),
                  }}
                />
              ) : (
                <p>
                  As part of its collaboration with the mobile network operator
                  Wataniya Télécom Algérie (Ooredoo), Medialgeria has deployed a
                  multimedia device (TV, Press, Radio and digital) for the
                  “Hanya” campaign, a new prepaid offer that offers customers a
                  10-second step rate at the best market prices in Algeria.
                </p>
              )}
            </div>
          </div>
        </div>
      </section>
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4">
              <div className="logoFooter_content">
                <div className="footer_logo">
                  <img src={Logo} alt="footer logo" />
                </div>
                <div className="footer_content">
                  {footerData ? (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: footerData.description
                          .replace(/\r\n/g, "<br/>")
                          .replace(/\n/g, "<br/>"),
                      }}
                    />
                  ) : (
                    <p>Loading Api Data...</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="navigation-footer">
                <h4>{headerTranslations[language]?.ourservices}</h4>
                <ul>
                  <li>
                    <Link to="/news">{headerTranslations[language]?.news}</Link>
                  </li>
                  <li>
                    <Link to="/agency">
                      {headerTranslations[language]?.agency}
                    </Link>
                  </li>
                  <li>
                    <Link to="/service">
                      {headerTranslations[language]?.services}
                    </Link>
                  </li>
                  <li>
                    <Link to="/work">{headerTranslations[language]?.work}</Link>
                  </li>
                  <li>
                    <Link to="/team">{headerTranslations[language]?.team}</Link>
                  </li>
                  <li>
                    <Link to="/contact"></Link>
                    {headerTranslations[language]?.contact}
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="footerContact_info">
                <h4>{headerTranslations[language]?.contact}</h4>
              </div>
              <div className="footerContact_data">
                <ul>
                  <li>{headerTranslations[language]?.contact}:- +9645689866</li>
                  <li>
                    {headerTranslations[language]?.email}:- info@medialgeria.com
                  </li>
                  <li>
                    {headerTranslations[language]?.address}:- 16122 Collins
                    Street, Melbourne, Australia
                  </li>
                </ul>
              </div>
              {/* <Link to="/contact" className="link">
                Get in touch
              </Link> */}
              <ul className="my-4 social">
                <li>
                  <Link
                    to="https://www.facebook.com/medialgeria/"
                    target="_blank"
                  >
                    <FaFacebookF />
                  </Link>
                </li>
                <li>
                  <Link href="#" target="_blank">
                    <FaTwitter />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQFLIm8hcMZygAAAAZG8qETwur3Uzvotg1uL5nQzzNIUTZR-X5fqW-nzhAu8LcBV1Tt4KamACgeaXdCmL3ypUUsKR0tNO1jdyL5JW5y05ftYOC8Mc2XWQdSaAlhRGzFdQTLhbEw=&original_referer=&sessionRedirect=https%3A%2F%2Ffr.linkedin.com%2Fcompany%2Fmedialgeria"
                    target="_blank"
                  >
                    <FaLinkedinIn />
                  </Link>
                </li>
                <li>
                  <Link href="#" target="_blank">
                    <FaGooglePlusG />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.youtube.com/channel/UCDjQDI9xZ_qh2AW8ohoZRjw"
                    target="_blank"
                  >
                    <FaYoutube />
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-12">
              <div className="footer-bar">
                <span className="copyright">
                  © 2024 Medialgeria | All Rights Reserved
                </span>
                <span className="creation">
                  Site created by
                  <Link to="https://www.webnmobappssolutions.com/">
                    webnmobapps solutions Pvt. Ltd
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default HanayaOoredoo;
